export default __webpack_public_path__ + "static/media/certificat.745e7bd2.svg";